/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CommandSuccessViewModel } from '../models/CommandSuccessViewModel';
import type { CreateSearchSuggestionCommand } from '../models/CreateSearchSuggestionCommand';
import type { SearchSuggestionViewModel } from '../models/SearchSuggestionViewModel';
import type { UpdateSearchSuggestionCommand } from '../models/UpdateSearchSuggestionCommand';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SearchSuggestionsAdminService {
    /**
     * @returns SearchSuggestionViewModel Success
     * @throws ApiError
     */
    public static getApiSearchSuggestionsAdmin(): CancelablePromise<Array<SearchSuggestionViewModel>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/search-suggestions-admin',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param requestBody
     * @returns SearchSuggestionViewModel Success
     * @throws ApiError
     */
    public static postApiSearchSuggestionsAdmin(
        requestBody?: CreateSearchSuggestionCommand,
    ): CancelablePromise<SearchSuggestionViewModel> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/search-suggestions-admin',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @param requestBody
     * @returns SearchSuggestionViewModel Success
     * @throws ApiError
     */
    public static putApiSearchSuggestionsAdmin(
        id: string,
        requestBody?: UpdateSearchSuggestionCommand,
    ): CancelablePromise<SearchSuggestionViewModel> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/search-suggestions-admin/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Invalid access token`,
            },
        });
    }
    /**
     * @param id
     * @returns CommandSuccessViewModel Success
     * @throws ApiError
     */
    public static deleteApiSearchSuggestionsAdmin(
        id: string,
    ): CancelablePromise<CommandSuccessViewModel> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/search-suggestions-admin/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Invalid access token`,
            },
        });
    }
}
